"use client";

import dynamic from "next/dynamic";

const GeneratorView = dynamic(
    () => import("@/components/generator-view").then((m) => ({ default: m.GeneratorView })),
    { ssr: false },
);

/**
 * Dedicated route for image generation. Mirrors the experience the
 * /create hub leads to and gives every scenario a real (dashboard)
 * page with the same DashboardHeader + MobileBottomNav chrome.
 */
export default function ImageGenerationPage() {
    return (
        <GeneratorView
            defaultMode="image"
            hideHeader
            className="h-[calc(100dvh-64px-64px-env(safe-area-inset-bottom))] md:h-[calc(100dvh-64px)] pb-0"
        />
    );
}
